import React from "react"

import Icon from "icons"
import {
  Wrapper,
  Carousel,
  Slider,
  ImageSlide,
  Slide,
  DesktopImage,
  ImageCreditSource,
  Arrows,
  StyledButtonBack,
  StyledButtonNext,
} from "./styles"

const Images = ({ images = [] }) => {
  const formatCreditSource = (credit, source) =>
    credit ? `Image by ${credit}${source ? ` / ${source}` : ""}` : "\u00a0"

  return (
    <Wrapper>
      <Carousel naturalSlideWidth={1} naturalSlideHeight={1} totalSlides={images.length}>
        <Slider>
          {images.map((image) => (
            <ImageSlide key={image.id}>
              <Slide>
                <DesktopImage
                  imageData={image}
                  sizes={[
                    {
                      query: 0,
                      width: 387,
                      height: 258,
                      transforms: `c_fill,g_auto,w_387,h_258,q_auto,f_auto,fl_lossy`,
                    },
                  ]}
                  alt={image.altText}
                  lazy
                />
                <ImageCreditSource>
                  {formatCreditSource(image.credit, image.source)}
                </ImageCreditSource>
              </Slide>
            </ImageSlide>
          ))}
        </Slider>
        {images.length > 1 && (
          <Arrows>
            <StyledButtonBack>
              <Icon id="arrow-left" width={20} height={20} />
            </StyledButtonBack>
            <StyledButtonNext>
              <Icon id="arrow-right" width={20} height={20} />
            </StyledButtonNext>
          </Arrows>
        )}
      </Carousel>
    </Wrapper>
  )
}

export default Images
